export default function Wordmark({ style = {} }) {
  return (
    <span className="wordmark" style={style}>
      <span className="wordmark-classroom">classroom.</span>
      <span className="wordmark-bingo">bingo</span>
    </span>
  );
}
